module.exports = __webpack_public_path__ + "img/class6.1ee58738.png";